import { useTranslation } from 'react-i18next';
import { MovementsList } from '@/common/components/MovementsList/MovementsList';
import { OperationsList } from '@/common/components/OperationsList/OperationsList';
import { MARKET } from '@/common/constants/markets';
import { HomeSection } from '@/common/containers/Dashboard/Home/HomeSection/HomeSection';
import { useMarket } from '@/common/hooks/useMarket';
import { useGetOperations } from '@/common/integrations/menhir/employee/operations/operations.hooks';
import { useMovements } from '@/web/hooks/useMovements';
import { Href, useRouter } from 'expo-router';

export type TActivitySectionProps = {
  seeAllRoute?: Href;
};

export function ActivitySection({ seeAllRoute }: TActivitySectionProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const { slug } = useMarket();

  return (
    <HomeSection
      title={t('full_italy_home.last_activity')}
      action={
        seeAllRoute
          ? {
              children: t('general.see_all'),
              onPress: () => {
                router.navigate(seeAllRoute);
              },
            }
          : undefined
      }
    >
      {slug === MARKET.PT ? (
        <MovementsActivityList />
      ) : (
        <OperationsActivityList />
      )}
    </HomeSection>
  );
}

function MovementsActivityList() {
  const { movements, isLoading } = useMovements({
    page: 1,
    perPage: 5,
  });
  const movementsList = movements?.list ?? [];
  return <MovementsList movements={movementsList} loading={isLoading} />;
}

function OperationsActivityList() {
  const { operations, isLoading } = useGetOperations({
    page: 1,
    perPage: 5,
  });

  const operationsList = operations?.list ?? [];
  return <OperationsList operations={operationsList} loading={isLoading} />;
}
